import React, {useMemo, memo} from 'react';
import {Transition, TransitionGroup} from 'components';
import {TimeTooltip, Header, TimeGrid, CurrentTime, CalendarDay} from '.';
import {usePrevious, useNamedSelector, useKey} from 'helpers';
import {navigate} from 'store/calendar';
import css from './today.module.scss';

export function Home() {
  const { dates, currentDate } = useNamedSelector('calendar.settings');

  const step = dates.length == 7 ? 7 : 1;
  const slide = {
    prev: () => navigate( currentDate.clone().add(-1*step, 'day') ),
    next: () => navigate( currentDate.clone().add(+1*step, 'day') ),
  }

  const prev = usePrevious(dates[0]);
  const diff = useMemo(() => dates[0].diff(prev, 'day'), [ dates[0] ]);
  const className = css(
    'length-' + dates.length,
    'slide-' + Math.abs(diff) + '-days',
    diff > 0 ? 'slide-right' : 'slide-left'
  );

  useKey(({ key }) => /Arrow(Right|Left)/.test(key) && window.document.activeElement == window.document.body, ({ key }) => {
    key == 'ArrowRight' ? slide.next() : slide.prev();
  });

  return (
    <main className={css('bleed', 'wrapper')}>
      <Header slide={slide} className={className} />
      <div className={css('section', className)}>
        <TimeGrid />
        <CurrentTime />
        <div className={css.canvas} id="calendar-timetable">
          <TransitionGroup>
            { [ dates ].map(dates =>
              <Transition key={dates.join(',')} timeout={200}>
                { transition =>
                  <Columns dates={dates} transition={transition} />
                }
              </Transition>
            ) }
          </TransitionGroup>
        </div>
      </div>
      <TimeTooltip />
    </main>
  );
}

const Columns = memo(({ dates, transition }) => {
  return (
    <ul className={css('columns', transition)}>
      { dates.map(date =>
        <CalendarDay key={date.unix()} date={date} />
      ) }
    </ul>
  );
});
